const ASSESSMENT_STATUS = {
    PUBLISHED: 'published',
    ARCHIVED: 'archived',
    DRAFT: 'draft',
}
export default ASSESSMENT_STATUS
